import React, { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { Form, Formik } from "formik";
import CustomConfirmBox from "../../DashBoard/customConfirmBox";
import bankingService from "../../../components/Services/banking.service";
import { disableButton, enableButton } from "../../../store/ButtonFlag/actions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { toastProperties } from "../../../commons/Toast/Toaster";
import Chat from "../../../components/chat/Chat";
import documentUploadService from "../../../components/Services/documentUpload.service";
import UploadedDocument from "../../Documents/UploadedDocument";
import InfoExcangeModal from "../../../components/InfoExchangeModal/InfoExcangeModal";

const ReceivedBankingRequests = ({
 isOpen,
 selectedCardData,
 closeReceivedBankModal,
 getReceivedConnectionsBanknig,
 getMatchingBankingListings,
 getBankingLedger,
}) => {
  console.debug(isOpen)
 const [approveOpen, setApproveOpen] = useState(false);
 const [ledgerOpen, setLedgerOpen] = useState(false);
 const [rejectOpen, setRejectOpen] = useState(false);
 const [isOpenChat, setOpenChat] = useState(false);
 const [withdrawOpen, setWithdrawOpen] = useState(false);
 const [closedOpen, setClosedOpen] = useState(false);
 const [UserCapName, setUserCapName] = useState(null);
 const [fileType, setFileType] = useState("");
 const [isOpenDoc, setIsOpenDoc] = useState(false);
 const [selectedFileData, setSelectedFileData] = useState(null);
 const [showUploadAgreement,setShowUploadAgreement] = useState(false)
 const [viewMore,setViewMore] = useState(false)

   const [infoModal, setInfoModal] = useState(false);
   const [infoData, setInfoData] = useState(isOpen);

 const buttonRef = useRef(null);

 const currentRoute = window.location.pathname;
 const isButtonEnabled = useSelector(
  (state) => state?.buttonReducer?.isButtonEnabled
 );
 const configKey = useSelector((state) => state?.sessionState?.connectionName);
 let myListing = isOpen?.bankingListing
 let counterPartyListing = isOpen?.againstBankingListing
 const dispatch = useDispatch();

 const handleApprove = () => {
  setApproveOpen(!approveOpen);
 };
 const handleLedger = ()=>{
  // setShowUploadAgreement(!showUploadAgreement);
  setLedgerOpen(!ledgerOpen)
 }
 const handleClose = (uploadedAgreementId) => {
  disableButton()(dispatch);
  const data = {
   id: isOpen?.id,
   status: rejectOpen
    ? "REJECTED"
    : withdrawOpen
    ? "WITHDRAWN"
    : ledgerOpen 
    ? "LEDGER"
    : approveOpen
    ? "ACCEPTED"
    : closedOpen
    ? "CLOSED"
    : '',
  };
  if (typeof(uploadedAgreementId) == 'number') {
    data.agreementDocumentId = uploadedAgreementId;
  }
  bankingService
   .updateBankingConnectionStatus(data)
   .then((response) => {
    if (response?.data?.code === 200) {
     setApproveOpen(false);
     setRejectOpen(false);
     closeReceivedBankModal();
     !ledgerOpen && getReceivedConnectionsBanknig && getReceivedConnectionsBanknig();
     selectedCardData && getMatchingBankingListings(selectedCardData?.id)
     getBankingLedger && getBankingLedger();
     ledgerOpen && window.location.replace("/banking");
     toast.success(response?.data?.message, toastProperties);
     enableButton()(dispatch);
    } else if (response?.data?.code !== 200) {
     enableButton()(dispatch);
    }
   })
   .catch((error) => {
    console.error("Api call Error :", error);
    enableButton()(dispatch);
   });
 };
 const handleReject = () => {
  setRejectOpen(!rejectOpen);
 };
 const handleWithdraw = () => {
  setWithdrawOpen(!withdrawOpen);
 };
 const handleClosedOpen = () => {
  setClosedOpen(!closedOpen);
 };
 const renderDateRangeSlots = (slotsList) => {
  return slotsList?.map((item, i) => (
   <small key={i}>
    {item?.dateStartAt} / {item?.dateEndAt} - {item?.slotStartAt} /
    {item?.slotEndAt}
   </small>
  ));
 };
 const getDocDataById = ()=>{
  documentUploadService.getDocumentById(isOpen?.agreementDocumentId).then((response)=>{
    if(response?.data?.code === 200){
        let fileTypeSplit = response?.data?.data?.fileName.split(".");
        setFileType(fileTypeSplit[fileTypeSplit?.length - 1]);
        setSelectedFileData(response?.data?.data?.fileInBytes);
        setIsOpenDoc(true);
    }
  }).catch(err=>console.log("Api call Error:",err));
 }
 const handleCloseModal = () => {
  setIsOpenDoc(false);
 };
 
 const handleViewDetails = () =>{
  setViewMore(!viewMore)
 }
 const handleOpenInfoModal = () => {
  setTimeout(() => {
    setInfoModal(true);
  }, 1000);
};
 return (
  <>
  {infoModal && (
    <InfoExcangeModal
      open={infoModal}
      handleClose={() => setInfoModal(false)}
      data={infoData}
    />
  )}
  {isOpenDoc && (
     <UploadedDocument
      fileData={selectedFileData}
      handleCloseModal={handleCloseModal}
      fileType={fileType}
      isOpen={isOpenDoc}
     />
    )}
   <Modal
    show={Boolean(isOpen)}
    onHide={closeReceivedBankModal}
    size="xl"
    centered
   >
    <Modal.Header closeButton>
     <Modal.Title>Banking Request</Modal.Title>
    </Modal.Header>
    <Modal.Body className="m-3 table-scrollY">
     <Formik>
      <Form >
       <div className=" table-responsive">
        <table className="table comparasion-table table-bordered">
         <tr>
          <th width="33%"></th>
          <th width="33%" className="approve-comprasion-first-col-header">
           {"My Listing"}
          </th>
          <th width="33%" className="approve-comprasion-second-col-header">
           {"Discom Listing"}
          </th>
         </tr>
         <tr>
          <td className="comp-text-right">Name</td>
          <td className="approve-comprasion-first-col">
           {myListing?.company?.companyName}
          </td>
          <td className={`approve-comprasion-second-col ${(isOpen?.status === "ACCEPTED" || isOpen?.status === "LEDGER" )? "" : 'company-name-blur'}`}>
           {counterPartyListing?.company?.companyName}
          </td>
         </tr>
         {/* <tr>
          <td className="comp-text-right">Region</td>
          <td className="approve-comprasion-first-col">
               {myListing?.company?.region}
          </td>
          <td className="approve-comprasion-second-col">
           {counterPartyListing?.company?.region}
          </td>
         </tr>
         <tr>
          <td className="comp-text-right">State</td>
          <td className="approve-comprasion-first-col">
           {myListing?.company?.state}
          </td>
          <td className="approve-comprasion-second-col">
           {counterPartyListing?.company?.state}
          </td>
         </tr> */}
         <tr>
          <td className="comp-text-right">Banking Factor(%)</td>
          <td className="approve-comprasion-first-col">
           {myListing?.bankingFactor}
          </td>
          <td className="approve-comprasion-second-col">
           {counterPartyListing?.bankingFactor}
          </td>
         </tr>
         <tr>
              <td className="comp-text-right">Settlement Rate (₹/KWH)</td>
              <td className="approve-comprasion-first-col">
              {myListing?.settlementRate}
              </td>
              <td className="approve-comprasion-second-col">
              {counterPartyListing?.settlementRate}
              </td>
        </tr>
         <tr>
          <td className="comp-text-right">Quantity (MW)</td>
          <td className="approve-comprasion-first-col">
           {myListing?.requiredQty}
          </td>
          <td className="approve-comprasion-second-col">
           {counterPartyListing?.requiredQty}
          </td>
         </tr>
         <tr>
          <td className="comp-text-right">Injection/Return Date-Time Range </td>
          <td className="approve-comprasion-first-col">
           <div className="date-time-list-first-col">
            {renderDateRangeSlots(myListing?.bankingSlotInjects)}
           </div>
          </td>
          <td className="approve-comprasion-second-col">
           <div className="date-time-list-second-col">
            {renderDateRangeSlots(counterPartyListing?.bankingSlotInjects)}
           </div>
          </td>
         </tr>
         <tr>
          <td className="comp-text-right">Drawal/Import Date-Time Range</td>
          <td className="approve-comprasion-first-col">
           <div className="date-time-list-first-col">
            {renderDateRangeSlots(myListing?.bankingSlotDrawls)}
           </div>
          </td>
          <td className="approve-comprasion-second-col">
           <div className="date-time-list-second-col">
            {renderDateRangeSlots(counterPartyListing?.bankingSlotDrawls)}
           </div>
          </td>
         </tr>
         <tr>
          <td className="comp-text-right">Expiry Date/Time </td>
          <td className="approve-comprasion-first-col">
           {myListing?.expiryAt}
          </td>
          <td className="approve-comprasion-second-col">
           {counterPartyListing?.expiryAt}
          </td>
         </tr>
         {
          viewMore && (
            <>
            <tr>
              <td className="comp-text-right">Minimum Slot</td>
              <td className="approve-comprasion-first-col">
              {myListing?.minimumSlots}
              </td>
              <td className="approve-comprasion-second-col">
              {counterPartyListing?.minimumSlots}
              </td>
            </tr>
            <tr>
              <td className="comp-text-right">Delivery Point</td>
              <td className="approve-comprasion-first-col">
              {myListing?.deliveryPoint}
              </td>
              <td className="approve-comprasion-second-col">
              {counterPartyListing?.deliveryPoint}
              </td>
            </tr>
            <tr>
              <td className="comp-text-right">Loss Adjustment Drawl</td>
              <td className="approve-comprasion-first-col">
              {myListing?.drawlRangeLossAdjustment}
              </td>
              <td className="approve-comprasion-second-col">
              {counterPartyListing?.drawlRangeLossAdjustment}
              </td>
            </tr>
            <tr>
              <td className="comp-text-right">Loss Adjustment Inject</td>
              <td className="approve-comprasion-first-col">
              {myListing?.injectRangeLossAdjustment}
              </td>
              <td className="approve-comprasion-second-col">
              {counterPartyListing?.injectRangeLossAdjustment}
              </td>
            </tr>
            <tr>
              <td className="comp-text-right">Comments</td>
              <td className="approve-comprasion-first-col">
              {myListing?.comments || "NA"}
              </td>
              <td className="approve-comprasion-second-col">
              {counterPartyListing?.comments || "NA"}
              </td>
            </tr>
            </>
          )
         }
        </table>
       </div>
      </Form>
     </Formik>
     {
      viewMore ? (
          <div onClick={handleViewDetails} className="view_more_less">
              <span>- View Less</span>
          </div>
      ):(
<div onClick={handleViewDetails}  className="view_more_less">
              <span>
                + View More
              </span>
            </div>
      )
     }
     <div
      className="company-profile-btn-group mt-4"
      style={{ justifyContent: "center" }}
     >
      {!getMatchingBankingListings && (
       <>
        {isOpen?.status === "PLACED" && <button
         className="btn btn-approve"
         type="button"
         onClick={handleApprove}
        >
         Accept
        </button>}
        {approveOpen && (
         <CustomConfirmBox
          title="Connect"
          message={`Do you want to accept this ${configKey.toLowerCase()}?`}
          open={approveOpen}
          handleClose={handleClose}
          handleCloseNo={handleApprove}
         />
        )}
        {isOpen?.status === "ACCEPTED" && <><button
         className="btn btn-approve"
         type="button"
         onClick={handleLedger}
        >
        Move to Ledger 
        </button>
        {ledgerOpen && (
         <CustomConfirmBox
          title="Connect"
          message={`Do you want to move this ${configKey.toLowerCase()} to Ledger?`}
          open={ledgerOpen}
          showUploadAgreement={showUploadAgreement}
          handleClose={handleClose}
          handleCloseNo={handleLedger}
         />
        )}</>}
        {(isOpen?.status !== "REJECTED" && isOpen?.status !== "LEDGER") &&<button
         className="btn btn-withdrawal"
         type="button"
         onClick={handleReject}
        >
         Decline
        </button>}
        {rejectOpen && (
         <CustomConfirmBox
          title="Decline"
          message={`Do you want to reject this ${configKey}?`}
          open={rejectOpen}
          // rejectConnection={rejectConnection}
          handleClose={handleClose}
          handleCloseNo={handleReject}
         />
        )}
       </>
      )}
      {currentRoute === "/banking" && (
       <>
        <button
         className="btn btn-withdrawal"
         type="button"
         onClick={handleWithdraw}
        >
         Withdraw
        </button>
        
        {withdrawOpen && (
         <CustomConfirmBox
          title="Withdraw"
          message="Do you want to withdraw the Capacity?"
          open={withdrawOpen}
          handleClose={handleClose}
          handleCloseNo={handleWithdraw}
         />
        )}
       </>
      )}
      {/* {isOpen?.status === "LEDGER" &&<button
         className="btn btn-login"
         type="button"
         onClick={getDocDataById}
        >
         View Agreement
        </button>} */}
        {currentRoute === "/banking_ledger" && (
       <>
        <button
         className="btn btn-approve"
         type="button"
         onClick={handleClosedOpen}
        >
         Close
        </button>
        
        {closedOpen&& (
         <CustomConfirmBox
          title="Withdraw"
          message="Do you want to Close the Connection?"
          open={closedOpen}
          handleClose={handleClose}
          handleCloseNo={handleClosedOpen}
         />
        )}
       </>
      )}
      <button
       className="btn btn-bookmark"
       type="button"
       onClick={() => {
        setOpenChat(true);
        setUserCapName({
         fromUser: myListing?.name,
         toUser: counterPartyListing?.name,
        });

       }}
       disabled={
        isOpen?.status === "PLACED" || isOpen?.status === "REJECTED"
         ? true
         : false
       }
      >
       Chat
      </button>
      <div
        className="d-flex btn btn-login"
        onClick={(e) => handleOpenInfoModal(e)}
      >
        Information Exchanges
      </div>
      {isOpenChat && (
       <Chat
        isOpen={isOpenChat}
        closeChatModal={() => {
         setOpenChat(false);
        }}
        UserCapName={UserCapName}
       />
      )}
     </div>
    </Modal.Body>
   </Modal>
  </>
 );
};

export default ReceivedBankingRequests;
